import axios from "axios";

// Module-level mirror of AuthProvider's targetOrigin. The 401 interceptor below runs outside
// React state, so it can't reach the AuthProvider's ref directly — instead AuthProvider calls
// setHttpServiceTargetOrigin() whenever it captures a new origin from the parent.
let httpServiceTargetOrigin = "*";

export const setHttpServiceTargetOrigin = (origin) => {
  if (origin) httpServiceTargetOrigin = origin;
};

// Response interceptor to read authError
axios.interceptors.response.use(undefined, async (error) => {
  const authError = error.response && error.response.status === 401;

  // In case of Unauthorized error of type token expiry, initiate the refresh token mechanism
  if (authError) {
    // the token expires, remove it from parent window's local storage.
    window?.parent?.postMessage({ token: null }, httpServiceTargetOrigin);
    window.location.reload();
    return Promise.reject(new Error("You need to login again"));
  }

  const permissionError = error.response && error.response.status === 403;

  if (permissionError) {
    return Promise.reject(
      new Error(
        "You are not authorized to access this content. Please contact admin for more details."
      )
    );
  }

  // Other errors
  const expectedError =
    error.response &&
    error.response.status >= 400 &&
    error.response.status < 500;
  if (expectedError && error.response.data && error.response.data[0]?.message) {
    return Promise.reject(new Error(error.response.data[0].message));
  }
  return Promise.reject(error);
});

export const initialiseHttpService = async (accessToken) => {
  axios.defaults.baseURL = `${process.env.REACT_APP_KANIS_API_URL}/api/v1/widget`;
  axios.defaults.headers.common["Content-Type"] = "application/json";
  axios.defaults.withCredentials = true;
  if (accessToken) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
  } else {
    delete axios.defaults.headers.common['Authorization'];
  }
};

export default {
  get: axios.get,
  post: axios.post,
  put: axios.put,
  patch: axios.patch,
  delete: axios.delete,
};
